import { render, staticRenderFns } from "./FlexPanel.vue?vue&type=template&id=437baaf9&"
import script from "./FlexPanel.vue?vue&type=script&setup=true&lang=js&"
export * from "./FlexPanel.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FlexPanel.vue?vue&type=style&index=0&id=437baaf9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports